<!--
 * @Author: cp
 * @Date: 2019-08-22 17:17:11
 * @Description: 快递单
 -->
<template>
  <div v-loading.fullscreen="loading">
    <el-card>
      <condition-search ref="search" :query-items="queryItems" :search-param="searchParam" @search="search"
        @reset="reset">
      </condition-search>
    </el-card>
    <el-card v-if="pageListData.length > 0">
      <el-statistic group-separator="," :value="statistic.numOfBill" title="单据数量"></el-statistic>
      <el-statistic group-separator="," :precision="3" :value="statistic.weightOfGood" title="货物总重量"></el-statistic>
      <el-statistic group-separator="," :precision="0" :value="statistic.numOfPackage" title="包裹数量"></el-statistic>
      <el-statistic group-separator="," :precision="2" :value="statistic.fareOfExpress" title="快递运费"></el-statistic>
    </el-card>
    <el-card>
      <div style="height: calc(100% - 45px);overflow: auto;">
        <el-table ref="table1" border :data="pageListData" :height="heightStyleObj" style="width:100%;margin-top: 10px">
          <el-table-column show-overflow-tooltip width="180px" label="发货日期">
            <template slot-scope="scope">
              {{ parseTime(scope.row.specifyDeliveryDate, '{y}-{m}-{d}') }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="orderCode" min-width="160px" label="订单编号">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="mailNo" width="160px" label="快递单母单号">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="trackMailNo" width="160px" label="签回单号">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="status" width="80px" label="运送状态">
            <template slot-scope="scope">
              <dict-tag :options="dictObj.transport_status" :value="scope.row.status" />
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="actualWeight" width="80px" label="货物总重量">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="number" width="80px" label="包裹数量">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="cost" width="80px" label="快递运费">
            <template slot-scope="scope">
              <dict-tag :options="dictObj.pay_method" :value="scope.row.payMethod" />
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" width="80px" label="寄件要求">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="receiverName" width="80px" label="收件人">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="receiverAddress" width="80px" label="收件人地址">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="receiverMobile" width="80px" label="收件人联系电话">
          </el-table-column>
          <el-table-column show-overflow-tooltip width="180px" label="创建时间">
            <template slot-scope="scope">
              {{ parseTime(scope.row.createTime, '{y}-{m}-{d}') }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" width="80px" label="备注">
          </el-table-column>
        </el-table>
        <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
          :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { getDict } from '@/api/common'
export default {
  name: 'ExpressBill',
  data() {
    return {
      queryItems:[],
      dictList: {
        pay_method: []
      },
      // 生产任务列表数据
      pageListData: [],
      loading: false,
      searchParam: {
        newCommonQuery: 'Y',
        allAndOr: 'and',
        pageNum: 1,
        pageSize: 100,
        total: 0,
        column: '',
        value: '',
        condition: ''
      },
      heightStyleObj: '',
      statistic: {
        numOfBill: 0,
        weightOfGood: 0.000,
        numOfPackage: 0,
        fareOfExpress: 0.00
      }
    }
  },
  created() {
    this.getDicts(['pay_method'])

    this.heightStyleObj = window.innerHeight - 425 + 'px'
  },
  methods: {
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },
    search(){
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    getPageListData() {
      // 获取拣货列表数据
      this.loading = true
      if (this.searchParam.column === 'specify_delivery_date') {
        this.searchParam.value = this.formatProductCodeDate(this.searchParam.value)
      }
      this.searchParam.status = 'ISSUE'
      this.publicApi.getMailInfoListV2(this.searchParam)
        .then(res => {
          if (res.code === '200' || res.data === []) {
            if (res.data === null) {
              this.pageListData = []
              this.searchParam.total = 0
            } else {
              this.pageListData = res.data.records
              this.searchParam.total = res.data.total
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.$message({
            type: 'error',
            message: '请求异常'
          })
        })
        .finally(() => { this.loading = false })
        .then(() => { this.getAggregation() })
    },
    getAggregation() {
      this.loading = true
      if (this.searchParam.column === 'specify_delivery_date') {
        this.searchParam.value = this.formatProductCodeDate(this.searchParam.value)
      }
      this.publicApi.getExpressAggregationV2(this.searchParam)
        .then(res => {
          if (res.code === '200' && res.data) {
            this.statistic = res.data
          } else {
            return Promise.reject(new Error('请求异常'))
          }
        })
        .catch((error) => {
          console.log(error)
          this.$message({
            type: 'error',
            message: '请求异常'
          })
        })
        .finally(() => { this.loading = false })
    },
  }
}

</script>

<style>
.pom-statistic-container {
  display: flex;
  font-size: 1.2rem;
  padding: 15px;
  border: 1px solid #dfdfdf;
  border-radius: 1px;
}

.pom-statistic {
  text-align: center;
}

.pom-statistic-title {
  font-weight: 500;
}

.pom-statistic-content {
  color: #004098;
}
</style>
